
import {ElementRef}         from '@angular/core';
import {first}              from "rxjs/operators";

import {Dialog}              from './dialog';
import {Logger}              from '@/util/logger';
import {IValidatorCallBack}  from './i.validator.call.back';
import {IOkCallBack}         from './i.ok.call.back';
import {ServiceManager}      from "@/services/service.manager";
import {Project}             from "@/models/project";
import {BatchGroupElement}   from "@/models/project/batch.group.element";
import {BlobType}            from "@/models/blob";

import * as $                from 'jquery';
import 'select2';
import {OptGroupData, OptionData, SearchOptions} from 'select2';

import {v4 as uuidv4} from 'uuid';
import {JSONBrowserMetadata} from "@/screens/ide/json.browser.metadata";
import {WindowType} from "@/screens/ide/window";
import {basename} from "@/util/util";

/**
 *
 * @class NewBatchSummaryDialog
 *
 * @brief dialog for bringing a batch (corridor) KPI together with a set of
 * regressions to generate a final "batch measure".
 *
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class NewBatchSummaryDialog extends Dialog {

  /** the name of the new batch summary */
  private name: string                                = '';

  /** if they drag and dropped, then this is the KPI object that was dropped */
  private kpi: any                                    = null;

  /** the name to use for the KPI object */
  private kpiName: string                             = '';

  /** if they selected a batch of batches to draw KPI rollup from, this is it. */
  private bob: BatchGroupElement                      = null;

  /** the blob(s) we're using as the regressions */
  private regressions: {label: string, key: string}[] = [];

  /** the set of possible patches where KPI rollups can come from  */
  private bobs: {label: string, bob: BatchGroupElement}[] = [];

  /** the current project */
  private project: Project                            = null;

  /** timer to wait for user to stop typing */
  private typingTimer                                 = null;

  private services: ServiceManager;

  /** standard constructor */
  constructor(
    host: ElementRef,
    services: ServiceManager
  ) {

    super(host);

    this.services = services;

    this.title = 'Create Batch Summary (Link to Batch)';
    this.icon = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewBatchSummaryDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    let nbsd: NewBatchSummaryDialog    = this;

    nbsd.validator                     = validator ? validator : null;
    nbsd.success                       = success   ? success   : null;

    nbsd.name                          = '';
    nbsd.kpi                           = '';

    let selectedBOB: BatchGroupElement = null;

    /* if they gave us a KPI to use...use it! */

    if (typeof options.kpi != 'undefined') {

      nbsd.kpi = options.kpi;
    }

    if (typeof options.bob != 'undefined') {

      selectedBOB = options.bob;
    }

    if (typeof options.project != 'undefined') {

      nbsd.project = options.project;
    }

    nbsd.disable();

    /* get the set of all possible KPI rollup, so we can build a select2 dropdown to use to pick from */

    nbsd.bobs        = nbsd.project.allRollupKPI();

    /* get the set of all possible regressions, when we create a measure, we do it with all possible */

    nbsd.regressions = nbsd.project.allRegressions();

    let regressionList: string = '';

    nbsd.regressions.forEach((item: {key: string, label: string}) => {

      regressionList += `<li>${item.label}</li>`;
    });

    Logger.debug('[NewBatchSummaryDialog] opening...');

    const body = $(nbsd.host).find('.modal-body');

    $(body).parent().css('min-height', '400px');

    const html = `
<div class="batch-summary-dialog">

  <div class="batch-summary-name">
    <label class="gui-label" style="text-align: right; width: 70px;">Name:</label>
    <input class="gui-input batch-name-input" style="width: 200px;" type="text" placeholder="Batch Summary Name">
  </div>

  <div class="batch-kpi-dnd">
    <span>Override KPI by dropping a KPI here.</span>
  </div>

  <div class="batch-summary-kpi-list" style="margin-top: 12px;">
    <label class="gui-label" style="width: 120px;">Batch:</label>
    <select class="gui-input batch-summary-kpi-picker bob-select"><option></option></select>
  </div>

  <div class="batch-summary-regression-list">
    <h4>Regressions</h4>
    <ul>
    ${regressionList}
    </ul>
  </div>

</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* insert the Select2 picker for the batch of batches KPI rollups */


    $('.bob-select').select2({
        placeholder: `Select...`,
           disabled: false,
         allowClear: false,
      closeOnSelect: true,
              width: '200px',
               data: nbsd.bobs.map((x) => {
        return {
            "id": x.label,
          "text": x.label,
           "bob": x.bob
        }
      })

    });

    $('.bob-select').on('select2:select', (e) => {

      nbsd.bob = e.params.data['bob'];

      Logger.debug('[NewBatchSummaryDialog] Batch of Batches picked: ', e.params.data['bob']);

      nbsd.validate();
    });

    /*
     * if they gave us an initial selection for the batch of batches...hunt it down and
     * select it.
     *
     */

    if (selectedBOB) {

      Logger.debug('[NewBatchSummaryDialog] auto-picking batch of batches: ', selectedBOB._label);

      $('.bob-select').val(selectedBOB._label).trigger('change.select2');

      nbsd.bob = selectedBOB;

      nbsd.validate();
    }

    /* enable drag 'n drop */

    const id: string            = $(nbsd.host).attr('id');
    const dropArea: HTMLElement = $(`#${id}`).find('.batch-kpi-dnd').get(0);

    /* we'll handle the related events, thank you. */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(dropArea).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(dropArea).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e: DragEvent) => {

      const dt: DataTransfer = e.dataTransfer;

      Logger.debug('[NewBatchSummaryDialog] dropping! ', e);

      nbsd.doDrop(dt);

    }, false);

    /* add behaviors */

    $(nbsd.host).find('.batch-name-input').on('input', (e) => {

      /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

      if (nbsd.typingTimer) {

        clearTimeout(nbsd.typingTimer);
      }

      nbsd.typingTimer = setTimeout(() => {

        const value: string = $(e.currentTarget).val() as string;

        nbsd.name = value;

        nbsd.validate();

      }, 400);

    });

    $(nbsd.host).find('.batch-name-input').on('keypress', (e) => {

      if (nbsd.typingTimer) {

        clearTimeout(nbsd.typingTimer);
      }

      nbsd.typingTimer = setTimeout(() => {

        const value: string = ($(e.currentTarget).val() as string).trim();

        nbsd.name = value;

        nbsd.validate();

      }, 400);

    });

    /* disable the Ok button...until we have valid input */

    nbsd.validate();
  }

  /** helper to handle setting an override KPI object via drag n' drop */
  doDrop(dt: DataTransfer) {

    let nbsd: NewBatchSummaryDialog = this;

    /* if we have a file...read it and JSON parse it... */

    if (dt.files.length > 0) {

      const f: File = dt.files[0];
      nbsd.kpiName = basename(f.name);

      Logger.debug('[NewBatchSummaryDialog] uploading override KPI ', f);

      /* read in the raw text */

      const reader   = new FileReader();

      reader.onerror = (msg) => {

        nbsd.error('Problems uploading: ' + msg);
      };

      reader.onload = (event: ProgressEvent<FileReader>) => {

        const text = event.target.result;

        /* we have the text try to convert to an object if we can */

        try {

          /* try to recover a KPI object */

          nbsd.kpi = JSON.parse(String(text));

          /* set the new drop area label ... */

          const id: string            = $(nbsd.host).attr('id');
          $(`#${id}`).find('.batch-kpi-dnd span').html(`Override: ${nbsd.kpiName}`);

          Logger.debug(`[NewBatchSummaryDialog] loaded KPI override (${nbsd.kpiName}):`, nbsd.kpi);

          nbsd.validate();

        } catch (e) {

          nbsd.error('Can not parse scenario JSON: ' + e);

          return ;
        }

      };

      reader.readAsText(f);
    }

  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    let nbsd: NewBatchSummaryDialog = this;

    nbsd.error('');

    /* assume its bad */

    nbsd.disable();

    if (!nbsd.validator) {

      nbsd.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(nbsd.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so it's ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        nbsd.validator({name: nbsd.name, kpi: nbsd.kpi, bob: nbsd.bob, regressions: nbsd.regressions}, resolve, reject);

      }).then((data: any) => {

        nbsd.enable();

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(nbsd.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        nbsd.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewBatchSummaryDialog] closing...');


  }

  /** dialog was accepted */
  public ok() {

    let nbsd: NewBatchSummaryDialog = this;

    Logger.debug('[NewBatchSummaryDialog] accepted: ');

    if (nbsd.success) {

      /*
       * we have the name, we have the regressions and for the KPI...we need a blob.  Either,
       * we create a temporary blob from the object they drag n' dropped (if there is one,
       * or we use the one the selected from the batch of batches dropdown.  Once we have
       * the KPI object as a temporary blob...then we can just pass it along with the other
       * parameters.
       *
       */

      if (nbsd.kpi) {

        /* map the drag n' dropped KPI object to a temporary blob */

        /* name was set as part of the drop operation */

        Logger.debug(`[NewBatchSummaryDialog] accepting with d'n'd KPI (${nbsd.kpiName})`, nbsd.kpi);

        nbsd.successTempBlob(nbsd.kpiName, nbsd.kpi);

      } else {

        /* map the batch of batches to a KPI rollup, then map that to a temporary blob */

        Logger.debug(`[NewBatchSummaryDialog] generating KPI rollup for batch of batches:`, nbsd.bob);

        /* first we have to get the KPI rollup... */

        const pending = $.Deferred();

        pending.then((results: any) => {

            nbsd.kpi     = results;
            nbsd.kpiName = `${nbsd.bob._label}-kpi.json`;

            Logger.debug(`[NewBatchSummaryDialog] accepting with batch of batch KPI (${nbsd.kpiName})`, nbsd.kpi);

            nbsd.successTempBlob(nbsd.kpiName, nbsd.kpi);

          },
          (error) => {

            Logger.error(`[NewBatchSummaryDialog] (view) could not fetch KPI content: `, error);

          });

        nbsd.bob.perCorridorKPI(pending);

      }

    }

  }

  /** map this object to a temporary blob, and then use it invoke the success method */
  successTempBlob(name: string, kpi: any) {

    const key: string = `/tmp/${uuidv4()}/${name}`;
    this.project.services.blobber.create(key, BlobType.Json, JSON.stringify(kpi), name, 'temp kpi file')
      .pipe(first())
      .subscribe(
        (blob) => {

          Logger.debug(`[NewBatchSummaryDialog] new temporary blob saved (${name}): `, key);

          this.success( {
                   name: this.name,
                kpiBlob: key,
                    kpi: null,
                   blob: null,
            regressions: this.regressions.map(x => x.key)
          });

        },
        (error) => {

          Logger.error('[NewBatchSummaryDialog] could not save temporary blob: ', error);

        });

  }
}
